import React from "react"
import Header from "./Header"

const GreenHeader = props => (
  <Header type="green" {...props} />
)

export default GreenHeader
